var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-opensans",attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('div',{staticClass:"app-content"},[_c('div',{staticClass:"sidebar-container"},[_c('Sidebar')],1),_c('div',{staticClass:"main-content"},[_c('router-view')],1)]):_c('Login',{on:{"login":_vm.handleLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }